import React from "react";

import { Text } from "../../atoms/Text/Text";
import { Block } from "../../atoms/Layout/Block/Block";
import { Pages, Categories } from "../../constants/Pages";
import styles from "./CategoryDescriptionBlock.css";

type CategoryDescriptionBlockProps = {
  Arena5Slug: Pages | Categories;
};

export class CategoryDescriptionBlock extends React.PureComponent<CategoryDescriptionBlockProps> {
  render() {
    const { Arena5Slug } = this.props;

    if (Arena5Slug === Categories.Juegos) {
      return (
        <div>
          <Block className={styles.contentDescroptionText}>
            <Block as="p">
              Aquí encontrarás juegos en español y una selección de los más
              populares en inglés. Te invitamos a que los explores todos, muchos
              son intuitivos y podrás participar sin importar el idioma. Revisa
              las categorías por medio de las pestañas de navegación que
              encontrarás en la parte superior de la página y asegúrate de
              explorar la pestaña designada “More” para ver más opciones.
              Recuerda que puedes acceder a cualquier juego en tu computadora,
              teléfono móvil o tableta. Y ahora también puedes comparar tu
              puntaje y clasificación con la de otros jugadores con el marcador
              de puntajes. Guarda esta página como favorita en todos tus
              dispositivos y ¡acepta el desafío!
            </Block>
          </Block>

          <Block as="p">
            <LinkMore href="/games/mahjongg-dimensions?intcmp=AM-A5GAM-CTGES-TXT-MJNGDIM">
              Mahjongg Dimensions
            </LinkMore>
          </Block>

          <Block as="p">
            <LinkMore href="/games/mahjongg-dark-dimensions?intcmp=AM-A5GAM-CTGES-TXT-MJNGDIMDRK">
              Mahjongg Dark Dimensions
            </LinkMore>
          </Block>

          <Block as="p">
            <LinkMore href="/games/spider-solitaire?intcmp=AM-A5GAM-CTGES-TXT-SOLSPDR">
              Spider Solitaire
            </LinkMore>
          </Block>

          <Block as="p">
            <LinkMore href="/games/candy-mahjongg?intcmp=AM-A5GAM-CTGES-TXT-MJNGCND">
              Mahjongg Candy
            </LinkMore>
          </Block>

          <Block as="p">
            <LinkMore href="/games/trizzle?intcmp=AM-A5GAM-CTGES-TXT-TRZL">
              Trizzle
            </LinkMore>
          </Block>

          <Block as="p">
            <ButtonLink href="/category/all-games?intcmp=AM-A5GAM-CTGES-CTA-CTGALL">
              <Text bold={true}>MIRA TODOS LOS JUEGOS</Text>
            </ButtonLink>
          </Block>

          <Block as="p">
            <LinkMore href="https://www.aarp.org/espanol/instrucciones-para-juegos/?Intcmp=AM-A5GAM-CTGES-TXT-INSTRUCCIONESJUEGOS-ES">
              Lee instrucciones en español
            </LinkMore>
            &nbsp;de cómo jugar los juegos más populares. ¿Tienes más
            preguntas?&nbsp;
            <LinkMore href="https://www.aarp.org/espanol/ayuda-para-juegos/?intcmp=AM-A5GAM-CTGES-TXT-AYUDAJUEGOS-ES">
              Consulta nuestra página de ayuda para juegos.
            </LinkMore>
          </Block>

          <Block as="p">
            Solve crosswords and word puzzles in Spanish! Brushing up on your
            language skills is as easy as playing games. For more engaging
            Spanish language content,&nbsp;
            <LinkMore href="https://www.aarp.org/espanol/?intcmp=AM-A5GAM-CTGES-TXT-AARPES">
              visit AARP en español
            </LinkMore>
          </Block>
        </div>
      );
    }

    if (Arena5Slug === Categories.Rewards) {
      return (
        <div>
          <Block className={styles.contentDescroptionText}>
            <Block>
              <Block as="p">
                AARP Rewards is AARP’s loyalty program that rewards you for a
                life well played. Now, you can earn points by solving your
                favorite crossword puzzles on AARP Games!
              </Block>
              <Block as="p">
                Score up to 900 points each day when you tackle the Daily
                Crossword, Mini Crossword and Let’s Crossword, the multiplayer
                game you can solve with friends. Finish one puzzle daily across
                each crossword type to earn your points.
              </Block>
              <Block as="p">
                Watch your points rack up. Then, redeem for points-only deals,
                discounted gift cards, sweepstake entries, exclusive daily deals
                and more.
              </Block>
              <Block as="p">
                As an AARP Member, you get even more. Earn 50% more points on
                each activity and get exclusive access to member-only rewards.
              </Block>
              <Block as="p">
                So, first things first. Get started with AARP Rewards and claim
                your 1,000 welcome points. Then, have even more fun earning
                points every day with your favorite crosswords!
              </Block>
            </Block>

            <Block className={styles.descriptionImageColumn}>
              <img
                width="160"
                height="157"
                title="AARP Rewards"
                alt="AARP Rewards logo"
                src="https://ams.cdn.arkadiumhosted.com/assets/arena-4/arena/heap/program%402x.png"
              />
            </Block>
          </Block>

          <Block>
            <ButtonLink
              href="https://www.aarp.org/rewards/?intcmp=AM-A5GAM-CTGRWDS-CTA-GTMRWDGAM-REWARDS"
              target="_blank"
              rel="noopener"
            >
              <Text bold={true}>Get started</Text>
            </ButtonLink>
          </Block>

          <LinkMore href="/help?intcmp=AM-A5GAM-CTGRWDS-HELP#q3_1">
            More about AARP Rewards category on Games &gt;
          </LinkMore>
        </div>
      );
    }

    if (Arena5Slug === Categories.StayingSharp) {
      return (
        <div>
          <Block className={styles.contentDescroptionText}>
            <Block>
              <Block as="p">
                AARP® Staying Sharp® is an award-winning digital program
                offering content about brain health, including fitness and
                health information, exercise videos, recipes with healthy
                ingredients, articles and more. Make time to focus on your brain
                health today!
              </Block>

              <Block as="p">
                <ul>
                  <li>
                    <strong>Engaging Articles</strong>
                    <Block as="p">
                      Read about the latest research with insights on{" "}
                      <LinkMore
                        data-categoryid="AARP Games"
                        data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-SS-HEALTHY_HABITS"
                        target="_blank"
                        rel="noopener"
                        href="https://stayingsharp.aarp.org/articles/?intcmp=DSM-SSS--PROMO-habits"
                      >
                        healthy habits
                      </LinkMore>{" "}
                      that may have an impact on brain health.
                    </Block>
                  </li>

                  <li>
                    <strong>Challenges</strong>
                    <Block as="p">
                      Explore topics such as memory, problem solving, focus and
                      mental well-being in a series of challenges designed to
                      help you learn about building healthy habits.
                    </Block>
                  </li>

                  <li>
                    <strong>
                      Cognitive Assessment, Lifestyle Check-Ins and Additional
                      Tests
                    </strong>
                    <Block as="p">
                      Try the Cognitive Assessment, which can give you a view
                      into how you’re performing today and enable you to learn
                      about strategies to help support brain health as we age.
                      You may take the assessment every 30 days.
                    </Block>
                  </li>

                  <li>
                    <strong>Recipes, Exercise Videos and More</strong>
                    <Block as="p">
                      Try a different spin on a favorite recipe or learn some
                      new yoga poses. There are far too many{" "}
                      <LinkMore
                        data-categoryid="AARP Games"
                        data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-SS-GREAT_ACTIVITIES"
                        target="_blank"
                        rel="noopener"
                        href="https://stayingsharp.aarp.org/activities/?intcmp=DSM-SSS--PROMO-activities"
                      >
                        great activities
                      </LinkMore>{" "}
                      to list here, so you’ll have to take our word for it.
                    </Block>
                  </li>
                </ul>
              </Block>

              <Block as="p">
                And don’t forget our{" "}
                <LinkMore
                  target="_blank"
                  rel="noopener"
                  href="https://stayingsharp.aarp.org/games-play/?intcmp=DSM-SSS--PROMO-games"
                >
                  Games and Puzzles
                </LinkMore>
                , which offer fun diversions when you need a break.
              </Block>

              <br />

              <Block as="p">
                <ButtonLink
                  data-categoryid="AARP Games"
                  data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-SS-GET_STARTED_TODAY"
                  target="_blank"
                  rel="noopener"
                  href="https://stayingsharp.aarp.org/about/get-started/?intcmp=DSM-SSS--PROMO-SSGetStarted"
                >
                  <Text bold={true}>Get Started Today!</Text>
                </ButtonLink>
              </Block>

            </Block>
            <Block className={styles.descriptionImageColumn}>
              <img
                width="165"
                alt="AARP Staying Sharp logo"
                title="AARP Staying Sharp"
                src="https://aarpcloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-aarp/images/SS-Logo-Opt 4-@2x.jpg"
              />
            </Block>
          </Block>
        </div>
      );
    }

    return null;
  }
}

const ButtonLink = (props: any) => (
  <a className={styles.buttonLink} {...props} />
);
const LinkMore = (props: any) => <a className={styles.linkMore} {...props} />;
